module.exports = __webpack_public_path__ + "img/demonhunter.9418427b.jpg";